import { useEffect, useRef } from 'react';

// The composer is sticky inside the thread's scroll container (or right below it),
// so the newest content must stay above it: jump to the end on new messages, and
// stay pinned there while the thread, the composer or the scroller itself resizes
// — unless the reader scrolled up. The scroller is the thread's own element, or an
// ancestor's (`scroller`, a ref already attached when the thread mounts).
export default function useThreadScroll(messageCount, projectId, scroller) {
  const ownRef = useRef(null);
  const scrollerRef = scroller || ownRef;
  const pinned = useRef(true);
  useEffect(() => {
    pinned.current = true;
    const el = scrollerRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [messageCount, projectId, scrollerRef]);
  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return undefined;
    const observer = new ResizeObserver(() => { if (pinned.current) el.scrollTop = el.scrollHeight; });
    [el, ...el.children].forEach(node => observer.observe(node));
    const onScroll = () => { pinned.current = el.scrollHeight - el.scrollTop - el.clientHeight < 32; };
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      observer.disconnect();
      el.removeEventListener('scroll', onScroll);
    };
  }, [scrollerRef]);
  return { scrollerRef };
}
